import { Battery, Card, Typography } from '@sonnen/web-ui';
import { Link } from 'react-router-dom';
import { AppRoute } from '../../constants';
import { useTranslation } from '../../i18n/i18n';
import styles from './LoginPromptCard.module.css';

type LoginCardProps = {
  i18nScope: 'modules.priceOptimization' | 'loginPromptCard';
};

const LoginPromptCard = ({ i18nScope }: LoginCardProps) => {
  const { t } = useTranslation();

  return (
    <Card
      paddingSize="sm"
      className={styles.loginPromptCard}
      dataTestId="login-prompt"
      withBottomSpace={false}
    >
      <div className={styles.cta}>
        <div>
          <Battery size="xl" />
        </div>
        <p>
          <Typography.Label2>{t(`${i18nScope}.loginTitle`)}</Typography.Label2>
          <Typography.Body2 variant="secondary">{t(`${i18nScope}.loginText`)}</Typography.Body2>
        </p>
      </div>
      <Typography.Body1>
        <Link to={AppRoute.LOGIN} data-testid="login-prompt-button">
          {t(`${i18nScope}.loginButton`)}
        </Link>
      </Typography.Body1>
    </Card>
  );
};

export default LoginPromptCard;
